export enum messageOwnerTypes {
  COMMON_INBOX = 'commonInbox',
  INSTITUTION_PROFILE = 'institutionProfile',
  OTP_INBOX = 'otpInbox',
}
